import { render, staticRenderFns } from "./edit-create-address-modal.vue?vue&type=template&id=2013e0aa"
import script from "./edit-create-address-modal.vue?vue&type=script&lang=ts"
export * from "./edit-create-address-modal.vue?vue&type=script&lang=ts"
import style0 from "./edit-create-address-modal.vue?vue&type=style&index=0&id=2013e0aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports